export const name = 'SelectAccountController';
export default function SelectAccountController(
  $mdDialog,
  $gzAnalytics,
  contexts,
  targetContext
) {

  //noinspection BadExpressionStatementJS
  'ngInject';

  /* jshint validthis: true */
  var vm = this;
  vm.sending = false;
  vm.errorKey = null;

  vm.submit = submit;
  vm.cancel = cancel;

  activate();

  ////////////////

  function activate() {
    vm.contexts = _.sortBy(contexts, context => {
      return context.name.toLocaleLowerCase();
    });

    if (_.get(targetContext, 'id')) {
      vm.selectedContext = targetContext;
    }
  }

  function submit() {
    $mdDialog.hide(vm.selectedContext);
    $gzAnalytics.event('select account', {context: vm.selectedContext.name});
  }

  function cancel($event) {
    $mdDialog.cancel();
    $gzAnalytics.eventCancel('select account - cancelled');
  }
}



// WEBPACK FOOTER //
// ./components/sign-in/select-account/select-account.controller.js